
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PatchRecommendationRequest,
  RecommendationRequest,
  SimpleError,
} from '../models';
import {
    PatchRecommendationRequestFromJSON,
    PatchRecommendationRequestToJSON,
    RecommendationRequestFromJSON,
    RecommendationRequestToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
} from '../models';

export interface AskRecommendationRequest {
    recommendationRequest: RecommendationRequest;
}

export interface PatchRecommendationVisibilityRequest {
    recommendationId: string;
    patchRecommendationRequest: PatchRecommendationRequest;
}

/**
 * 
 */
export class RecommendationsApi extends runtime.BaseAPI {

    /**
     * Ask a recommendation for a profile 
          */
    async askRecommendationRaw(requestParameters: AskRecommendationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['recommendationRequest'] == null) {
            throw new runtime.RequiredError(
                'recommendationRequest',
                'Required parameter "recommendationRequest" was null or undefined when calling askRecommendation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/recommendation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecommendationRequestToJSON(requestParameters['recommendationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Ask a recommendation for a profile 
          */
    async askRecommendation(requestParameters: AskRecommendationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.askRecommendationRaw(requestParameters, initOverrides);
    }

    /**
     * Update recommendation visibility 
          */
    async patchRecommendationVisibilityRaw(requestParameters: PatchRecommendationVisibilityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['recommendationId'] == null) {
            throw new runtime.RequiredError(
                'recommendationId',
                'Required parameter "recommendationId" was null or undefined when calling patchRecommendationVisibility().'
            );
        }

        if (requestParameters['patchRecommendationRequest'] == null) {
            throw new runtime.RequiredError(
                'patchRecommendationRequest',
                'Required parameter "patchRecommendationRequest" was null or undefined when calling patchRecommendationVisibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/recommendations/{recommendationId}`.replace(`{${"recommendationId"}}`, encodeURIComponent(String(requestParameters['recommendationId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchRecommendationRequestToJSON(requestParameters['patchRecommendationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update recommendation visibility 
          */
    async patchRecommendationVisibility(requestParameters: PatchRecommendationVisibilityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.patchRecommendationVisibilityRaw(requestParameters, initOverrides);
    }

}
